
import { Component, Prop, Vue } from 'vue-property-decorator'

import DeunaModel from '../models/Deuna'

import isMobile from '@/widget/utils/isMobile'
import EButton from './Button.vue'
import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EButton,
    EPaymentInfo,
  },
})
export default class Deuna extends Vue {
  @Prop({ required: true }) readonly deuna!: DeunaModel

  showOpenAppButton = isMobile()

  get isInstructionsVisible(): boolean {
    return this.deuna.instructions.filter(Boolean).length > 0
  }

  private payInApp() {
    window.open(this.deuna.appLink, '_blank')
  }
}
